import { render, staticRenderFns } from "./CardSections.vue?vue&type=template&id=24f06218"
import script from "./CardSections.vue?vue&type=script&lang=js"
export * from "./CardSections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports